import React from "react";
import styles from "./styles.module.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { IMAGE_URL_v4 } from "../../../../envs/prod/constants";
import CustomNextImage from "../Common/CustomNextImage";

const ReviewsComponent = ({ windowSize }) => {
  const reviews = [
    {
      id: 1,
      desc: "Seekho se mujhe | Rs 8000 ka fayda | hua hai, jo meine Share market ki series se seekha.",
      name: "Dr. Baijnath Jaiswal",
      occupation: "Dental Surgeon, Gorakhpur",
      image: `/assets/usersLove/baijnath.webp`,
    },
    {
      id: 2,
      desc: "Seekho se investing seekh ke | 30% ka profit | kamaya hai.",
      name: "Sandeep Kumar",
      occupation: "Private job, Haryana",
      image: `/assets/usersLove/sandeep.webp`,
    },
    {
      id: 3,
      desc: "Seekho se | Government docs ke baare me seekh | ke ab apne Cafe me aadhar pan ki services deta hun.",
      name: "Neeraj",
      occupation: "Cyber Cafe, Bihar",
      image: `/assets/usersLove/neeraj.webp`,
    },
    {
      id: 4,
      desc: "Seekho se maine | video editing | seekha. Aaj jo kuch bhi hu Seekho ki wajah se hu.",
      name: "Shivam",
      occupation: "BA Student, Delhi",
      image: `/assets/usersLove/shivam.webp`,
    },
    {
      id: 5,
      desc: "Seekho par | Time waste nahi | hota. Yaha hoti hai Seedhi baat no bakwaas.",
      name: "Md. Valiuddin",
      occupation: "Govt Employee, UP",
      image: `/assets/usersLove/valiuddin.webp`,
    },
  ];

  const news = [
    {
      id: 1,
      url: "https://yourstory.com/2023/07/bangalore-startup-building-netflix-educational-content",
      title:
        "This Bangalore startup is building a Netflix for educational content",
      date: "Jul 2023",
      img: `${IMAGE_URL_v4}/home/new_story.webp`,
    },
    {
      id: 2,
      url: "https://inc42.com/startups/2023-in-review-the-best-of-inc42s-30-startups-to-watch/",
      title: "Seekho featured in Top 30 Startups To Watch: 2023",
      date: "DEC 2023",
      img: `${IMAGE_URL_v4}/home/inc_Startups.webp`,
    },
    {
      id: 3,
      url: "https://www.3one4capital.com/blogs/3one4-capital-secures-exit-seekho",
      title: "3one4 exits Seekho with 7.5x return",
      date: "Apr 2023",
      img: `${IMAGE_URL_v4}/home/news_xone.webp`,
    },
  ];

  return (
    <div>
      <h6 className="text-[30px] font-semibold text-center font-inter lg:text-[40px]">
        1 Cr+ Users Ka Bharosa
      </h6>
      <h6 className="text-[15px] font-normal text-center tracking-wide mt-3 lg:text-[16px]">
        Seekho Ban Raha Hai Bharat Ka Favourite!
      </h6>

      <Swiper
        centeredSlides={true}
        loop={true}
        slidesPerView={"auto"}
        initialSlide={1}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={true}
        navigation={true}
        modules={[Autoplay, Pagination, Navigation]}
        style={{ height: "100%", paddingBottom: "100px" }}
        className={`reviews_wrapper_swiper ${styles.reviews_wrapper_swiper}`}
      >
        {windowSize >= 768
          ? [...reviews, ...reviews]?.map((data, index) => (
              <SwiperSlide
                className="border-1 p-2 !h-[220px] !max-h-[240px] border-[#666398] relative rounded-xl !w-[400px] ml-10"
                key={index}
              >
                <div
                  className="text-[18px] mt-4 text-[#d4d2ff]"
                  style={{ fontFamily: "Inter" }}
                >
                  <span className="opacity-80">{data.desc.split("|")[0]}</span>
                  <span className="font-bold text-[#d4d2ff]">
                    {data.desc.split("|")[1]}
                  </span>
                  <span className="opacity-80 text-[#d4d2ff]">
                    {data.desc.split("|")[2]}
                  </span>
                </div>
                <div className="flex gap-x-5 items-center absolute bottom-5">
                  <CustomNextImage
                    src={data?.image}
                    alt={data?.name}
                    width={60}
                    height={60}
                    priority={true}
                    className="w-[60px] h-[60px] rounded-full"
                  />
                  <div>
                    <div className="text-[#817aff] text-[18px]">
                      {data.name}
                    </div>
                    <div className="text-[12px] text-gray-400">
                      {data.occupation}
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))
          : reviews?.map((data, index) => (
              <SwiperSlide className="border-1 p-3 !h-[190px] !max-h-[220px] border-[#666398] relative rounded-xl">
                <div
                  className="text-[16px] text-[#d4d2ff]"
                  style={{ fontFamily: "Inter" }}
                >
                  <span className="opacity-80">{data.desc.split("|")[0]}</span>
                  <span className="font-bold text-[#d4d2ff]">
                    {data.desc.split("|")[1]}
                  </span>
                  <span className="opacity-80 text-[#d4d2ff]">
                    {data.desc.split("|")[2]}
                  </span>
                </div>
                <div className="flex gap-x-5 items-center absolute bottom-5">
                  <CustomNextImage
                    src={data?.image}
                    alt={data?.name}
                    width={50}
                    height={50}
                    className="w-[50px] h-[50px] rounded-full"
                  />
                  <div>
                    <div className="text-[#817aff] text-[18px]">
                      {data.name}
                    </div>
                    <div className="text-[12px] text-gray-400">
                      {data.occupation}
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
      </Swiper>

      {/* <div className={styles.investor_section}>
        <div className="hidden lg:block">
          <InvestorComponent />
        </div>
      </div> */}

      {/* <div className="-mt-8 lg:mt-4">
        <div>
          <div className={styles.news_title}>In the News</div>
          {windowSize >= 768 ? (
            <div className={styles.reviews_wrapper_swiper}>
              {news?.map((data, index) => (
                <a
                  target="_blank"
                  href={data.url}
                  style={{ textDecoration: "none" }}
                  key={index}
                >
                  <div className={styles.in_the_news_wrapper_card} key={index}>
                    <div className={styles.in_the_news_wrapper_up}>
                      <img
                        alt="seekho"
                        src={data.img}
                        className={styles.inthe_news_img}
                        style={{ height: "140px" }}
                      />
                    </div>
                    <div className={styles.in_the_news_wrapper_down}>
                      <div
                        className={styles.slide_reviews_title}
                        style={{ height: "80px" }}
                      >
                        {data.title}
                      </div>
                      <div className={styles.slide_reviews_date}>
                        {data.date}
                      </div>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          ) : (
            <Swiper
              centeredSlides={true}
              // loop={true}
              slidesPerView={"auto"}
              initialSlide={0}
              navigation={false}
              pagination={windowSize >= 768 ? false : true}
              modules={windowSize >= 768 ? [] : [Pagination]}
              style={{ height: "100%" }}
              className={styles.reviews_wrapper_swiper}
            >
              {news?.map((data, index) => (
                <SwiperSlide
                  className={styles.in_the_news_wrapper_card}
                  style={{ height: "330px" }}
                  key={index}
                >
                  <a
                    target="_blank"
                    href={data.url}
                    style={{ textDecoration: "none" }}
                  >
                    <div className={styles.in_the_news_wrapper_up}>
                      <CustomNextImage
                        src={data.img}
                        alt="seekho"
                        width={380}
                        height={200}
                        priority={true}
                        className={styles.inthe_news_img}
                        // style={{ height: "200px" }}
                      />
                    </div>
                    <div className={styles.in_the_news_wrapper_down}>
                      <div
                        className={styles.slide_reviews_title}
                        style={{ height: "80px" }}
                      >
                        {data.title}
                      </div>
                      <div className={styles.slide_reviews_date}>
                        {data.date}
                      </div>
                    </div>
                  </a>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </div>
      </div> */}
    </div>
  );
};

export default ReviewsComponent;
